import { server_connection } from 'config';

export const GET_QUESTION          = '[QUESTION APP] GET QUESTION';
export const GET_QUESTION_LIST     = '[QUESTION APP] GET QUESTION LIST';
export const UPDATE_QUESTION       = '[QUESTION APP] UPDATE QUESTION';
export const DELETE_QUESTION       = '[QUESTION APP] DELETE QUESTION';
export const CREATE_QUESTION       = '[QUESTION APP] CREATE QUESTION';
export const GET_QUESTION_TYPES    = '[QUESTION APP] GET QUESTION TYPES';


export function getQuestion(question_id) {
    return (dispatch, getState) => {
        fetch(server_connection+'/question/get/'+question_id)
            .then((response) => response.json())
            .then((questionData) => {
                dispatch({
                    type: GET_QUESTION,
                    payload: questionData,
                });
            });
    }
}

export function updateQuestion(question_id, question) {
    return (dispatch, getState) => {
        fetch(server_connection+'/question/update',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ question_id: question_id, question: question })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: UPDATE_QUESTION,
                    payload: question,
                });
            });
    }
}

export function deleteQuestion(question_id) {
    return (dispatch, getState) => {
        fetch(server_connection+'/question/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ question_id: question_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: DELETE_QUESTION,
                    payload: question_id,
                });
            });
    }
}

export function createQuestion(question) {
    return (dispatch, getState) => {
        fetch(server_connection + '/question/create',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ question: question })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: CREATE_QUESTION,
                    payload: question,
                });
            });
    }
}

export function getQuestionList() {
    return (dispatch, getState) => {
        fetch(server_connection+'/question/list')
            .then((response) => response.json())
            .then((questionList) => {
                dispatch({
                    type: GET_QUESTION_LIST,
                    payload: questionList,
                });
            });
    }
}

export function getQuestionTypes() {
    return (dispatch) => {
        fetch(server_connection + '/question/types')
            .then((response) => response.json())
            .then((questionTypes) => {
                dispatch({
                    type: GET_QUESTION_TYPES,
                    payload: questionTypes
                })
            });
    }
}


// WEBPACK FOOTER //
// src/main/content/question/store/actions/question.actions.js